import { RoleName } from '~/graphql/graphql';

const config = {
  locale: 'nl',
  fallbackLocale: 'en',
  amountOfAmbulanceSlots: 2,
  maxAmountOfDays: 4,
  recommendedVolunteersPerWish: 2,
  minVolunteersPerWish: 1,
  maxVolunteersPerWish: 4,
  volunteerRoles: [RoleName.Nurse, RoleName.Driver, RoleName.Photographer],
  subscriptionRemountInterval: 300_000,
  sentryDsn: 'https://51e58b1a7a8043acd823c006a18bd051@sentry.netvlies.nl/210',
} as const;

export default config;
